// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServicePrices_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /so/additional_service_prices/get/{id}.
 * O preco em REAIS, como as listagens — o form edita o que o wire fala.
 */
import type { AdditionalServicePrices_PriceRow } from './AdditionalServicePrices_PriceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AdditionalServicePrices_GetResponseDados {
row?: AdditionalServicePrices_PriceRow
}

export type AdditionalServicePrices_GetResponse = ApiResponse<AdditionalServicePrices_GetResponseDados>;

registerResponseContract('AdditionalServicePrices_GetResponse', {
  row: {
    type: 'object',
    required: false,
    fields: {
      so_additional_service_price_id:            { type: 'number',  required: true },
      so_additional_service_price_additional_id: { type: 'number',  required: false },
      so_additional_service_price_franchise_id:  { type: 'number',  required: false },
      so_additional_service_price_price:         { type: 'number',  required: false },
      so_additional_service_price_deadline_days: { type: 'number',  required: false },
      so_additional_service_price_active:        { type: 'number',  required: false },
      so_additional_service_price_created_at:    { type: 'string',  required: false },
      so_additional_service_name:                { type: 'string',  required: false },
      so_additional_service_default_price:       { type: 'number',  required: false },
      so_service_category_name:                  { type: 'string',  required: false },
      franquia:                                  { type: 'string',  required: false },
    },
  },
})
